<template>
  <li class="wf-flex wf-flex-wrap wf-justify-between wf-w-full wf-py-2 wf-items-center">
    <span
      class="wf-font-light wf-lowercase wf-text-gray-500 wf-w-1/2 wf-text-xs wf-tracking-wide"
    >Change Icon</span>
    <button
      @click="openIconModal"
    ><span
      class="wf-text-xs wf-text-blue-600 wf-mr-1"
    >Load Icons</span><i class="far fa-edit wf-text-blue-600"></i></button>
  </li>
</template>

<script>
  import MenuContentProperty from '../contracts/MenuContentProperty'
  export default MenuContentProperty.extend({
    methods: {
      openIconModal() {
        let iconSelected = `${this.elementContent.class} ${this.elementContent.icon}`;
        this.$modal.show('editorIconModal', {
          ...this.element,
          module: this.module,
          elementContent: iconSelected
        })
      },
    },
  })
</script>
